import { ReactElement } from 'react';
import { useAbility } from '@casl/react';
import { Navigate } from 'react-router-dom';
import { AbilityContext } from 'app/atoms';
import { useUserInfo } from 'app/hooks/useUserInfo';
import { Spin } from 'antd';
import { usePermissions } from 'app/hooks/usePermissions';

const Authorize = (props: AuthorizeInterface): ReactElement => {
  const { requiredPermissions, children, redirect, checkSubject = false, subject } = props;

  const ability = useAbility(AbilityContext);
  const { hasVisibility } = usePermissions();

  const { data: userInfo, isLoading } = useUserInfo();

  if (isLoading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75">
        <Spin size="large" />
      </div>
    );
  }

  const isAllowed = (action: string, subject: string) => {
    if (!userInfo) {
      return false;
    }

    const canAccess = ability.can(action, subject);

    return canAccess;
  };

  const handleUnauthorizedAccess = () => {
    if (redirect) {
      return <Navigate to={redirect} />;
    }
    return null;
  };

  const isAuthorized = () => {
    // If checkSubject is true and subject is provided, check subject-level permission directly
    if (checkSubject && subject) {
      const isVisible = hasVisibility(subject);
      return isVisible;
    } else {
      const authorized = requiredPermissions?.some((permission) => isAllowed(permission.action, permission.subject));
      return authorized;
    }
  };

  return <>{isAuthorized() ? children : handleUnauthorizedAccess()}</>;
};

interface AuthorizeInterface {
  requiredPermissions?: { action: string; subject: string }[];
  children: React.ReactNode;
  redirect?: string;
  checkSubject?: boolean; // to check the subject / module level permission
  subject?: string;
}
export default Authorize;
